import React from 'react';
import './ColoredSection.css';

const ColoredSection = ({ onBookNowClick }) => {
  return (
    <div className="colored-section">
      <div className="colored-section-content">
        <div className="section-heading">
          <h2>Our Service Area</h2>
        </div>
        <div className="left-column">
          <div className="map-circle">
            <img src="/images/calgary-map.png" alt="Map of Calgary" className="calgary-map" />
          </div>
        </div>
        <div className="section-body">
          <p>
            We proudly serve the entire Calgary area, providing top-notch electrical services to homes and businesses. Whether you're in the city center or the surrounding communities, our expert electricians are ready to assist you with all your electrical needs.
          </p>
          <button className="schedule-appointment-button" onClick={onBookNowClick}>Schedule Appointment</button>
        </div>
      </div>
    </div>
  );
};

export default ColoredSection;
